import React from "react";

export default function FilterBar({ children }) {
  return (
    <div className="flex flex-wrap items-end gap-3 rounded-lg border border-gray-800 bg-gray-900/40 p-4">
      {children}
    </div>
  );
}
